var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconSignOut = function SvgIconSignOut(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.75 4.75h5a1 1 0 1 0 0-2H4.5A1.75 1.75 0 0 0 2.75 4.5v15a1.75 1.75 0 0 0 1.75 1.75h5.25a1 1 0 1 0 0-2h-5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.605 7.355a1 1 0 0 1 1.415 0l3.937 3.938a1 1 0 0 1 0 1.414l-3.937 3.938a1 1 0 0 1-1.415-1.415l2.23-2.23H9.75a1 1 0 1 1 0-2h8.086l-2.23-2.23a1 1 0 0 1 0-1.415"
  }))));
};
export default SvgIconSignOut;